import { useApolloClient } from '@apollo/client';
import { useCallback } from 'react';
import {
    type SubmitGiftVoucherAdyenPaymentMutation,
    type SubmitGiftVoucherAdyenPaymentMutationVariables,
    SubmitGiftVoucherAdyenPaymentDocument,
} from '../../../../../api/mutations/submitGiftVoucherAdyenPayment';
import { type AgreementValues } from '../../../../shared/CIPage/ConsentAndDeclarations/useAgreementsValues';

const useGiftVoucherAdyenDepositSubmission = () => {
    const apolloClient = useApolloClient();

    return useCallback(
        async (token: string, values: AgreementValues, skipDeposit: boolean, sessionResult?: string) => {
            const { data } = await apolloClient.mutate<
                SubmitGiftVoucherAdyenPaymentMutation,
                SubmitGiftVoucherAdyenPaymentMutationVariables
            >({
                mutation: SubmitGiftVoucherAdyenPaymentDocument,
                variables: {
                    token,
                    agreedConsents: Object.entries(values)
                        .filter(Boolean)
                        .map(([consentId, agreementFields]) => (agreementFields.isAgreed ? { id: consentId } : null))
                        .filter(Boolean),
                    skipDeposit,
                    sessionResult,
                },
            });

            return data.result;
        },
        [apolloClient]
    );
};

export default useGiftVoucherAdyenDepositSubmission;
